// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"71d936251d906614","6831":"a83eea0132891a4c","8503":"102b753a97ad272a","9683":"ceba2204cb0f42bc"}[chunkId] + ".js";
};